import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE + '/api/config'

export default {
  namespaced: true,
  state: {
    price_types: []
  },
  mutations: {
    setPriceTypes (state, payload) {
      state.price_types = payload.price_types
    }
  },
  actions: {
    async getProductConf ({
      state,
      commit
    }) {
      const promise = axios.get(baseURL)
      promise.then(response => {
        commit('setPriceTypes', response.data)
      })
      return promise
    }
  }
}
